module.exports = __webpack_public_path__ + "img/TvDip-start_spinner.1fced2.svg";